import React from "react";
import styles from "./ui.module.css";

export type InputColor = "gray" | "outline";
export type InputSize = "small" | "medium" | "large";

type InputOwnProps = {
  color?: InputColor;
  size?: InputSize;
  width?: number | string;
  minWidth?: number | string;
};

export type InputProps = InputOwnProps &
  Omit<
    React.InputHTMLAttributes<HTMLInputElement>,
    keyof InputOwnProps
  >;

function toCssLength(value: number | string | undefined): string | undefined {
  if (value === undefined) return undefined;
  if (typeof value === "number") return `${value}px`;
  return value;
}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  (
    {
      className = "",
      color = "gray",
      size = "medium",
      width,
      minWidth,
      style,
      ...rest
    },
    ref
  ) => {
    const sizeClass =
      size === "small"
        ? styles.InputSmall
        : size === "large"
          ? styles.InputLarge
          : styles.InputMedium;
    const colorClass =
      color === "outline" ? styles.InputOutline : styles.InputGray;

    const mergedStyle: React.CSSProperties = { ...(style || {}) };
    const w = toCssLength(width);
    const mw = toCssLength(minWidth);
    if (w !== undefined) mergedStyle.width = w;
    if (mw !== undefined) mergedStyle.minWidth = mw;

    return (
      <input
        ref={ref}
        className={`${styles.SharedInput} ${sizeClass} ${colorClass}${
          className ? ` ${className}` : ""
        }`}
        style={mergedStyle}
        {...rest}
      />
    );
  }
);

Input.displayName = "Input";

export default Input;
